import MapHelpers from '../../map.utils';
import addSimpleGeoJsonSource from '../layer-utils/add-simple-geojson-source';
import MapLayerIcon from '../map-layer-icon';
import MapLayerVisibility from '../map-layer-visibility.enum';
import MapLayer from '../map-layer.enum';

// A property added when cluster: true on a GeoJSON Source.
const GLOBAL_ICON_SCALE_FACTOR = 1.2;
const POINT_COUNT = 'point_count';

function setIndustryNewsLayer(layerId: MapLayer | string, metadata?: {}) {
  const clusterLayerId = MapLayer.INDUSTRY_NEWS_CLUSTERS;
  const clusterCountLayerId = MapLayer.INDUSTRY_NEWS_CLUSTER_COUNT;

  return new Promise((resolve) => {
    addSimpleGeoJsonSource(layerId, true);

    MapHelpers.addLayer({
      id: clusterLayerId,
      type: 'circle',
      source: layerId,
      filter: ['has', POINT_COUNT],
      metadata,
      layout: {
        visibility: MapLayerVisibility.VISIBLE,
      },
      paint: {
        'circle-color': '#4bf990',
        // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
        'circle-radius': ['step', ['get', POINT_COUNT], 10, 5, 15, 10, 20],
      },
    });

    MapHelpers.addLayer({
      id: clusterCountLayerId,
      type: 'symbol',
      source: layerId,
      filter: ['has', POINT_COUNT],
      metadata,
      layout: {
        visibility: MapLayerVisibility.VISIBLE,
        'text-field': ['get', 'point_count_abbreviated'],
        'text-allow-overlap': true,
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12,
      },
      paint: {
        'text-color': '#08182E',
      },
    });

    MapHelpers.addLayer({
      id: layerId,
      type: 'symbol',
      source: layerId,
      metadata,
      filter: ['!', ['has', POINT_COUNT]],
      layout: {
        visibility: MapLayerVisibility.VISIBLE,
        'icon-image': [
          'case',
          ['==', ['get', 'selected'], true],
          MapLayerIcon.INDUSTRY_NEWS.SELECTED,
          MapLayerIcon.INDUSTRY_NEWS.DEFAULT,
        ],
        // ensure selected industry news are always on top
        // coalesce makes it so selected:undefined or selected:null is treated as selected:false
        'symbol-sort-key': [
          'case',
          ['coalesce', ['get', 'selected'], false],
          1,
          0,
        ],
        'icon-allow-overlap': true,
        'icon-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          5,
          [
            'case',
            ['==', ['get', 'selected'], true],
            0.84 * GLOBAL_ICON_SCALE_FACTOR,
            0.7 * GLOBAL_ICON_SCALE_FACTOR,
          ],
          8,
          [
            'case',
            ['==', ['get', 'selected'], true],
            0.96 * GLOBAL_ICON_SCALE_FACTOR,
            0.8 * GLOBAL_ICON_SCALE_FACTOR,
          ],
          16,
          [
            'case',
            ['==', ['get', 'selected'], true],
            1.34 * GLOBAL_ICON_SCALE_FACTOR,
            1.2 * GLOBAL_ICON_SCALE_FACTOR,
          ],
        ],
      },
    });

    resolve(MapHelpers);
  });
}

export default setIndustryNewsLayer;
